<div fxFlex="100" fxLayout="column" class="page-wrapper">
  <app-header (toggleSidenav)="sidenav.toggle()" class="sticky"> </app-header>

  <div fxFlexFill class="background" style="height: 100%;">
      <router-outlet></router-outlet>
  </div>
</div>
